/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

/**
 *
 */
angular.module('bulbApp.contentEditorModule')
.factory('BulbToolbarExtensionFactory', ['MediumEditor', 'BulbBrowserService', function (MediumEditor, BulbBrowserService) {

  function isElementDescendantOfExtension(extensions, element) {

    if (!extensions) {
      return false;
    }

    return extensions.some(function (extension) {
      if (typeof extension.getInteractionElements !== 'function') {
        return false;
      }

      var extensionElements = extension.getInteractionElements();
      if (!extensionElements) {
        return false;
      }

      if (!Array.isArray(extensionElements)) {
        extensionElements = [extensionElements];
      }
      return extensionElements.some(function (el) {
        return MediumEditor.util.isDescendant(el, element, true);
      });
    });
  }

  var BulbToolbarExtension = MediumEditor.extensions.toolbar.extend({

    getInteractionElements: function() {
      return this.getToolbarElement();
    },

    getToolbarElement: function () {
      if (!this.toolbar) {
        this.toolbar = this.createToolbar();
      }

      return this.toolbar;
    },

    handleFocus: function() {
      this.modifySelection();
      this.checkState();
    },

    checkState: function () {
      var isClickingToolbar =
        isElementDescendantOfExtension(this.base.extensions, this.base.events.lastMousedownTarget);

      if (this.base.preventSelectionUpdates) {
        return;
      }

      // If no editable has focus OR selection is inside contenteditable = false
      // hide toolbar
      var focusedElement = this.base.getFocusedElement();
      if (!focusedElement) {
        return this.hideToolbar();
      }

      // If there's no selection element, selection element doesn't belong to this editor
      // or toolbar is disabled for this selection element
      // hide toolbar
      var selectionElement = MediumEditor.selection.getSelectionElement(this.window);
      if ((!selectionElement ||
        this.getEditorElements().indexOf(selectionElement) === -1 ||
        selectionElement.getAttribute('data-disable-toolbar')) && !isClickingToolbar) {
        return this.hideToolbar();
      }

      // Now we know there's a focused editable with a selection.

      // Check to see if the selection is inside a selectable-block, as we want to show the toolbar in that case.
      // However, if there is a contenteditable="true" child inside the block, then we want that to be
      // be selectable instead of the block itself, so we don't assume we will show the toolbar in that case.
      var foundContentEditableTrue = false;
      var foundDisableToolbar = false;
      var enableToolbar = MediumEditor.selection.findMatchingSelectionParent(function (el) {
        var contentEditable = el && el.getAttribute('contenteditable');
        if (contentEditable === 'true') {
          foundContentEditableTrue = true;
        }
        var disableToolbar = el && el.hasAttribute('disable-toolbar');
        if (disableToolbar) {
          foundDisableToolbar = true;
        }
        return (el && el.hasAttribute('selectable-block') && !foundContentEditableTrue);
      }, this.window);

      // If the updateOnEmptySelection option is true, show the toolbar
      if ((enableToolbar || (this.updateOnEmptySelection && this.static)) && !foundDisableToolbar) {
        return this.showAndUpdateToolbar();
      }

      // If we don't have a 'valid' selection or we explicity don't want the toolbar -> hide toolbar
      if ((foundDisableToolbar ||
        this.window.getSelection().toString().trim() === '' ||
        (this.allowMultiParagraphSelection === false && this.multipleBlockElementsSelected())) && !isClickingToolbar) {
        return this.hideToolbar();
      }

      if (BulbBrowserService.isTouchDevice()) {
        // This will work only on mobile devices, and it will check to make sure that you're clicking the toolbar,
        // and then properly handling the click events for the mobile devices.
        if (isClickingToolbar && !this.isToolbarDefaultActionsDisplayed() && selectionElement === false) {
          return false;
        }
      }

      this.showAndUpdateToolbar();
    },

    modifySelection: function () {
      var selection = this.window.getSelection();
      if (selection.rangeCount === 0) {
        return;
      }
      var selectionRange = selection.getRangeAt(0);

      /*
       * In firefox, there are cases (ie doubleclick of a word) where the selectionRange start
       * will be at the very end of an element.  In other browsers, the selectionRange start
       * would instead be at the very beginning of an element that actually has content.
       * example:
       *   <span>foo</span><span>bar</span>
       *
       * If the text 'bar' is selected, most browsers will have the selectionRange start at the beginning
       * of the 'bar' span.  However, there are cases where firefox will have the selectionRange start
       * at the end of the 'foo' span.  The contenteditable behavior will be ok, but if there are any
       * properties on the 'bar' span, they won't be reflected accurately in the toolbar
       * (ie 'Bold' button wouldn't be active)
       *
       * So, for cases where the selectionRange start is at the end of an element/node, find the next
       * adjacent text node that actually has content in it, and move the selectionRange start there.
       */
      if (this.standardizeSelectionStart &&
        selectionRange.startContainer.nodeValue &&
        (selectionRange.startOffset === selectionRange.startContainer.nodeValue.length)) {
        var selectedElement = MediumEditor.selection.getSelectionElement(this.window);
        // Find adjacent node only if the the selected element is valid element/node.
        if (selectedElement) {
          var adjacentNode = MediumEditor.util.findAdjacentTextNodeWithContent(
            selectedElement,
            selectionRange.startContainer,
            this.document);
          if (adjacentNode) {
            var offset = 0;
            while (adjacentNode.nodeValue.substr(offset, 1).trim().length === 0) {
              offset = offset + 1;
            }
            selectionRange = MediumEditor.selection.select(this.document, adjacentNode, offset,
              selectionRange.endContainer, selectionRange.endOffset);
          }
        }
      }
    },

    /*
     * @positionToolbar
     * This method must be overwritten and modified for mobile devices
     * because the default mobile toolbar is above the selection we must place
     * our custom toolbar bellow the selection.
     *
     * If medium-editor ever resolved issue #1040 this method could be
     * removed and we can set static and sticky variables to true
     * within the contenteditor-controller.js
     */
    positionToolbar: function (selection) {
            // position the toolbar at left 0, so we can get the real width of the toolbar
            this.getToolbarElement().style.left = '0';
            this.getToolbarElement().style.right = 'initial';

            var range = selection.getRangeAt(0),
                boundary = range.getBoundingClientRect();

            // Handle selections with just images
            if (!boundary || ((boundary.height === 0 && boundary.width === 0) && range.startContainer === range.endContainer)) {
                // If there's a nested image, use that for the bounding rectangle
                if (range.startContainer.nodeType === 1 && range.startContainer.querySelector('img')) {
                    boundary = range.startContainer.querySelector('img').getBoundingClientRect();
                } else {
                    boundary = range.startContainer.getBoundingClientRect();
                }
            }

            var containerWidth = this.window.innerWidth,
                toolbarElement = this.getToolbarElement(),
                toolbarHeight = toolbarElement.offsetHeight,
                toolbarWidth = toolbarElement.offsetWidth,
                halfOffsetWidth = toolbarWidth / 2,
                defaultLeft = this.diffLeft - halfOffsetWidth,
                elementsContainer = this.getEditorOption('elementsContainer'),
                elementsContainerAbsolute = ['absolute', 'fixed'].indexOf(window.getComputedStyle(elementsContainer).getPropertyValue('position')) > -1,
                positions = {},
                relativeBoundary = {},
                middleBoundary, elementsContainerBoundary;

            // If container element is absolute / fixed, recalculate boundaries to be relative to the container
            if (elementsContainerAbsolute) {
                elementsContainerBoundary = elementsContainer.getBoundingClientRect();
                ['top', 'left'].forEach(function (key) {
                    relativeBoundary[key] = boundary[key] - elementsContainerBoundary[key];
                });

                relativeBoundary.width = boundary.width;
                relativeBoundary.height = boundary.height;
                boundary = relativeBoundary;

                containerWidth = elementsContainerBoundary.width;

                // Adjust top position according to container scroll position
                positions.top = elementsContainer.scrollTop;
            } else {
                // Adjust top position according to window scroll position
                positions.top = this.window.pageYOffset;
            }

            middleBoundary = boundary.left + boundary.width / 2;
            positions.top += boundary.top - toolbarHeight - 5;

            toolbarElement.classList.add('medium-toolbar-arrow-under');

            if (BulbBrowserService.isMobile()) {
        positions.top += this.diffTop + toolbarHeight + boundary.height + 20;
              toolbarElement.classList.add('medium-toolbar-arrow-over');
              toolbarElement.classList.remove('medium-toolbar-arrow-under');
            }

            if (middleBoundary < halfOffsetWidth) {
                positions.left = defaultLeft + halfOffsetWidth;
                positions.right = 'initial';
            } else if ((containerWidth - middleBoundary) < halfOffsetWidth) {
                positions.left = 'auto';
                positions.right = 0;
            } else {
                positions.left = defaultLeft + middleBoundary;
                positions.right = 'initial';
            }

            ['top', 'left', 'right'].forEach(function (key) {
                toolbarElement.style[key] = positions[key] + (isNaN(positions[key]) ? '' : 'px');
            });
        }
  });

  return {
    CreateExtension: function CreateExtension(options) {
      return new BulbToolbarExtension(options);
    },
  };
}]);
